import React from 'react'
export default class SearchByMedia extends React.Component {
  constructor(props) {
    super(props);
    this.state = {value: ''};
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleChange(event) {
    this.setState({value: event.target.value});
  }

  handleSubmit(event) {
    this.props.parenthandleSubmit(this.state.value)
  }

  render() {
    return (
        <div className='form-inline form-group pull-left mt2 clear-margin-bottom'>
          <label className='titleHead ml5'> Search Jobs By Media: </label>
          <input className='no_pd ml5 form-control search-input' type = 'text' placeholder=" Media Id" value={this.state.value} onChange={this.handleChange}/>
          <button type="button" className="btn ml5 btn-default mds-btn-background" aria-label="Close" onClick={this.handleSubmit}>
            <span className="glyphicon glyphicon-search mt2 white" aria-hidden="true"></span>
          </button>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/SearchByMedia.jsx